module.exports = __webpack_public_path__ + "img/result_success.2ce3777.png";